<template>
	<div class="job-listing">
		<div :class="['job-listing--items', {'job-listing--items-loading': loadingJobs }]">
			<div class="job-listing--item">
				<ListItemHead
					v-if="withHead"
					:job="job"
					@save="$emit('save')"
					@closeMessages="$emit('jobChanged', job)"
					@closeAppointments="$emit('jobChanged', job)"
					@publish="$emit('publish')"
					@unpublish="$emit('unpublish')"
					@loadFavorites="onlyFavorites = true"
				/>
				<ResultsListing
					v-if="(isPublished || internal) || forceListing"
					:job="job"
					:only-favorites="onlyFavorites"
					:only-excluded="onlyExcluded"
					@messagesClosed="$emit('messagesClosed')"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import ListItemHead from "./listing/ListItemHead";
import ResultsListing from "@/vue/application/job/listing/Container";
import _ from "lodash";
import {PUBLISHED} from "@/helper/job/Status";
import {mapState} from "vuex";

export default {
	components: {
		ListItemHead,
		ResultsListing,
	},

	props: {
		jobs: {
			type: Array,
			required: true,
		},
		loadingJobs: {
			type: Boolean,
			required: false,
			default: false,
		},
		withHead: {
			type: Boolean,
			required: false,
			default: true
		},
		onlyExcluded: {
			type: Boolean,
			required: false,
			default: false
		},
		forceListing: {
			type: Boolean,
			required: false,
			default: false
		},
	},

	data ()
	{
		return {
			job: _.first(this.jobs), // only one job for now
			onlyFavorites: false,
		};
	},

	computed: {
		...mapState('auth', ['internal']),
		isPublished ()
		{
			return this.job.status === PUBLISHED;
		}
	},

	watch: {
		jobs (v)
		{
			if (v)
			{
				this.job = _.first(this.jobs);
			}
		}
	}
}
</script>
